import _ from 'lodash'
import store from '..'
import axios from 'axios'
import API from '@/common/api'
import LANG from '@/common/lang'
import CURRENCY from '@/common/currency'
import DATE from '@/common/date'

const LOCAL_FONT_LIST = [
  { family: 'Pretendard' },
  { family: 'Noto Sans' },
  { family: 'PT Serif' },
  { family: 'Raleway' }
]

export default {
  namespaced: true,
  state: {
    site: {
      title: LANG.valueObj(),
      logo: ''
    },
    lang: {
      default: LANG.default,
      current: LANG.default,
      info: LANG.list.map(x => x),
      usable: LANG.usable(),
      langValue: LANG.valueObj(),
      manual: LANG.list.filter(x => x.t).map(x => x.c),
      priorityAgent: false,
      hiddenLangFlag: false,
      langOrder: []
    },
    currency: {
      default: CURRENCY.default,
      info: CURRENCY.list,
      disabledCurrencySymbol: false,
      displayCurrencyType: 'symbol',
      displayCurrencyUnit: LANG.valueObj()
    },
    date: {
      default: DATE.default,
      list: DATE.list,
      dateFormat: DATE.dateFormat.map(d => d.picker)
    },
    font: {
      default: 'Pretendard',
      default2: '',
      default3: '',
      added: []
    },
    main: {
      menu: '',
      page: ''
    },
    colors: {
      activeMenuBg: 'rgba(19,19,19,1)',
      activeMenuText: 'rgba(255,255,255,1)',
      headerBg: 'rgba(255,255,255,1)',
      menuBtn: 'rgba(19,19,19,1)',
      menuBtn2: 'rgba(255,255,255,1)',
      dimm: 'rgba(0,0,0,0.75)',
      menuBg: 'rgba(255,255,255,1)',
      menuText: 'rgba(19,19,19,1)',
      footerBg: 'rgba(238,243,245,1)',
      footerText: 'rgba(164,164,164,1)'
    },
    pointcolors: {
      languageBg: 'rgba(255,255,255,1)',
      languageText: 'rgba(19,19,19,1)',
      mypageBg: 'rgba(234,84,4,1)',
      mypageText: 'rgba(255,255,255,1)',
      primaryColor1:'rgba(19,19,19,1)',
      primaryColor2:'rgba(19,19,19,1)',
      contentsBg: 'rgba(255,255,255,1)',
      contentsText: 'rgba(19,19,19,1)',
      defaultBtnBg: 'rgba(19,19,19,1)',
      defaultBtnText: 'rgba(255,255,255,1)',
      defaultBtn2Bg: 'rgba(19,19,19,1)',
      defaultBtn2Text: 'rgba(255,255,255,1)',
      countBg: 'rgba(234,84,4,1)',
      countText: 'rgba(255,255,255,1)',
      productActivate: 'rgba(234,84,4,1)',
      productBtncart: 'rgba(118,185,85,1)',
      amenityActivate: 'rgba(234,84,4,1)',
      amenityBtn: 'rgba(19,19,19,1)',
      amenityBtnText: 'rgba(255,255,255,1)',
      roomcontrolActivate: 'rgba(234,84,4,1)',
      globalIconType: 'bg',
      loadingBackground: 'rgba(0,0,0,0)'
    },
    imgs: {
      headerBg: '',
      headerBgRepeat: 'no-repeat',
      headerBgPosition: '50% 50%',
      headerBgSize: 'auto',
      menuBg: '',
      menuBgRepeat: 'no-repeat',
      menuBgPosition: '50% 50%',
      menuBgSize: 'auto'
    },
    skin: {
      menu: 'left',
      activeMenuType: 'default'
    },
    footer: {
      copyright: LANG.valueObj()
    },
    order: {
      tel: true,
      email: false,
      roomChargeMsgActive: false,
      roomChargeMsg: LANG.valueObj(),
      multiCart: false,
      taxActive: false,
      tax: '',
      tipActive: false,
      tip: []
    },
    guestType: null,
    checkinInfo: null,
    mypage: {
      room: true,
      disabledRoom: false,
      disabledMypage: false,
      disabledCart: false,
      checkin: false,
      checkout: false,
      coupon: true,
      cart: true,
      order: true,
      payment: true,
      reservation: true,
      mobility: false
    },
    inroom: {
      checkoutTrue: false,
      checkoutTrueUrl: {
        type: 'page',
        pageId: '',
        url: LANG.valueObj(),
        productId: '',
        target: false,
        pageId_input_active: false,
        pageIdInput: ''
      },
      checkoutFalse: false,
      checkoutFalseUrl: {
        type: 'page',
        pageId: '',
        url: LANG.valueObj(),
        productId: '',
        target: false,
        pageId_input_active: false,
        pageIdInput: ''
      }
    },
    responsive: {
      mobile: {
        site: {
          logo: ''
        },
        colors: {
          activeMenuBg: 'rgba(19,19,19,1)',
          activeMenuText: 'rgba(255,255,255,1)',
          headerBg: 'rgba(255,255,255,1)',
          menuBtn: 'rgba(19,19,19,1)',
          menuBtn2: 'rgba(255,255,255,1)',
          dimm: 'rgba(0,0,0,0.75)',
          menuBg: 'rgba(255,255,255,1)',
          menuText: 'rgba(19,19,19,1)',
          footerBg: 'rgba(238,243,245,1)',
          footerText: 'rgba(164,164,164,1)'
        },
        imgs: {
          headerBg: '',
          headerBgRepeat: 'no-repeat',
          headerBgPosition: '50% 50%',
          headerBgSize: 'auto',
          menuBg: '',
          menuBgRepeat: 'no-repeat',
          menuBgPosition: '50% 50%',
          menuBgSize: 'auto'
        }
      },
      tablet: {
        site: {
          logo: ''
        },
        colors: {
          activeMenuBg: 'rgba(19,19,19,1)',
          activeMenuText: 'rgba(255,255,255,1)',
          headerBg: 'rgba(255,255,255,1)',
          menuBtn: 'rgba(19,19,19,1)',
          menuBtn2: 'rgba(255,255,255,1)',
          dimm: 'rgba(0,0,0,0.75)',
          menuBg: 'rgba(255,255,255,1)',
          menuText: 'rgba(19,19,19,1)',
          footerBg: 'rgba(238,243,245,1)',
          footerText: 'rgba(164,164,164,1)'
        },
        imgs: {
          headerBg: '',
          headerBgRepeat: 'no-repeat',
          headerBgPosition: '50% 50%',
          headerBgSize: 'auto',
          menuBg: '',
          menuBgRepeat: 'no-repeat',
          menuBgPosition: '50% 50%',
          menuBgSize: 'auto'
        }
      }
    }
  },
  mutations: {
    init (state) {
      state.site = {
        title: LANG.valueObj(),
        logo: ''
      }
      state.lang = {
        default: LANG.default,
        current: LANG.default,
        info: LANG.list.map(x => x),
        usable: LANG.usable(),
        langValue: LANG.valueObj(),
        manual: LANG.list.filter(x => x.t).map(x => x.c),
        priorityAgent: false,
        hiddenLangFlag: false,
        langOrder: []
      }
      state.currency = {
        default: CURRENCY.default,
        info: CURRENCY.list,
        disabledCurrencySymbol: false,
        displayCurrencyType: 'symbol',
        displayCurrencyUnit: LANG.valueObj()
      }
      state.date = {
        default: DATE.default,
        list: DATE.list,
        dateFormat: DATE.dateFormat.map(d => d.picker)
      }
      state.font.default = 'Pretendard'
      state.font.default2 = ''
      state.font.default3 = ''
      state.font.added = []
      state.main = {
        menu: '',
        page: ''
      }
      state.colors = {
        activeMenuBg: 'rgba(19,19,19,1)',
        activeMenuText: 'rgba(255,255,255,1)',
        headerBg: 'rgba(255,255,255,1)',
        menuBtn: 'rgba(19,19,19,1)',
        menuBtn2: 'rgba(255,255,255,1)',
        dimm: 'rgba(0,0,0,0.75)',
        menuBg: 'rgba(255,255,255,1)',
        menuText: 'rgba(19,19,19,1)',
        footerBg: 'rgba(238,243,245,1)',
        footerText: 'rgba(164,164,164,1)'
      }
      state.pointcolors = {
        languageBg: 'rgba(255,255,255,1)',
        languageText: 'rgba(19,19,19,1)',
        mypageBg: 'rgba(234,84,4,1)',
        mypageText: 'rgba(255,255,255,1)',
        primaryColor1:'rgba(19,19,19,1)',
        primaryColor2:'rgba(19,19,19,1)',
        contentsBg: 'rgba(255,255,255,1)',
        contentsText: 'rgba(19,19,19,1)',
        defaultBtnBg: 'rgba(19,19,19,1)',
        defaultBtnText: 'rgba(255,255,255,1)',
        defaultBtn2Bg: 'rgba(19,19,19,1)',
        defaultBtn2Text: 'rgba(255,255,255,1)',
        countBg: 'rgba(234,84,4,1)',
        countText: 'rgba(255,255,255,1)',
        productActivate: 'rgba(234,84,4,1)',
        productBtncart: 'rgba(118,185,85,1)',
        amenityActivate: 'rgba(234,84,4,1)',
        amenityBtn: 'rgba(19,19,19,1)',
        amenityBtnText: 'rgba(255,255,255,1)',
        roomcontrolActivate: 'rgba(234,84,4,1)',
        globalIconType: 'bg',
        loadingBackground: 'rgba(0,0,0,0)'
      }
      state.imgs = {
        headerBg: '',
        headerBgRepeat: 'no-repeat',
        headerBgPosition: '50% 50%',
        headerBgSize: 'auto',
        menuBg: '',
        menuBgRepeat: 'no-repeat',
        menuBgPosition: '50% 50%',
        menuBgSize: 'auto'
      }
      state.skin = {
        menu: 'left',
        activeMenuType: 'default'
      }
      state.order = {
        tel: true,
        email: false,
        roomChargeMsgActive: false,
        roomChargeMsg: LANG.valueObj(),
        multiCart: false,
        taxActive: false,
        tax: '',
        tipActive: false,
        tip: []
      }
      state.responsive = {
        mobile: {
          site: {
            logo: ''
          },
          colors: {
            activeMenuBg: 'rgba(19,19,19,1)',
            activeMenuText: 'rgba(255,255,255,1)',
            headerBg: 'rgba(255,255,255,1)',
            menuBtn: 'rgba(19,19,19,1)',
            menuBtn2: 'rgba(255,255,255,1)',
            dimm: 'rgba(0,0,0,0.75)',
            menuBg: 'rgba(255,255,255,1)',
            menuText: 'rgba(19,19,19,1)',
            footerBg: 'rgba(238,243,245,1)',
            footerText: 'rgba(164,164,164,1)'
          },
          imgs: {
            headerBg: '',
            headerBgRepeat: 'no-repeat',
            headerBgPosition: '50% 50%',
            headerBgSize: 'auto',
            menuBg: '',
            menuBgRepeat: 'no-repeat',
            menuBgPosition: '50% 50%',
            menuBgSize: 'auto'
          }
        },
        tablet: {
          site: {
            logo: ''
          },
          colors: {
            activeMenuBg: 'rgba(19,19,19,1)',
            activeMenuText: 'rgba(255,255,255,1)',
            headerBg: 'rgba(255,255,255,1)',
            menuBtn: 'rgba(19,19,19,1)',
            menuBtn2: 'rgba(255,255,255,1)',
            dimm: 'rgba(0,0,0,0.75)',
            menuBg: 'rgba(255,255,255,1)',
            menuText: 'rgba(19,19,19,1)',
            footerBg: 'rgba(238,243,245,1)',
            footerText: 'rgba(164,164,164,1)'
          },
          imgs: {
            headerBg: '',
            headerBgRepeat: 'no-repeat',
            headerBgPosition: '50% 50%',
            headerBgSize: 'auto',
            menuBg: '',
            menuBgRepeat: 'no-repeat',
            menuBgPosition: '50% 50%',
            menuBgSize: 'auto'
          }
        }
      }
      state.footer = {
        copyright: LANG.valueObj()
      }
      state.mypage = {
        room: true,
        disabledRoom: false,
        disabledMypage: false,
        disabledCart: false,
        checkin: false,
        checkout: false,
        coupon: true,
        cart: true,
        order: true,
        payment: true,
        reservation: true,
        mobility: false
      }
      state.inroom = {
        checkoutTrue: false,
        checkoutTrueUrl: {
          type: 'page',
          pageId: '',
          url: LANG.valueObj(),
          productId: '',
          target: false,
          pageId_input_active: false,
          pageIdInput: ''
        },
        checkoutFalse: false,
        checkoutFalseUrl: {
          type: 'page',
          pageId: '',
          url: LANG.valueObj(),
          productId: '',
          target: false,
          pageId_input_active: false,
          pageIdInput: ''
        }
      }
    },
    setDefaultLang (state, data) {
      state.lang.info.forEach(function (x, i) {
        if (x.c === data) {
          state.lang.info[i].t = true
          if (!state.lang.manual.includes(x.c)) {
            state.lang.manual.push(x.c)
          }
        }
      })
    },
    setLangOrder (state, data) {
      state.lang.langOrder = data
    },
    setTranslate (state, data) {
      state.lang.manual = data
      state.lang.info.forEach(function (x, i) {
        state.lang.info[i].t = data.includes(x.c)
      })
    },
    setColors (state, data) {
      state.colors[data.target] = data.color
    },
    setPointcolors (state, data) {
      state.pointcolors[data.target] = data.color
    },
    setFooterCopyright (state, data) {
      state.footer.copyright[data.lang] = data.value
    },
    setFontFace (state, data) {
      const fontFamily = `font_${data.family.trim()}`
      if (document.head.getElementsByClassName(fontFamily).length === 0) {
        const fontface = document.createElement('style')
        const createFontFace = document.createTextNode(`
          @font-face{
            font-family: ${data.family};
            src: url(${data.uri});
          }
        `)
        fontface.setAttribute('class', fontFamily)
        fontface.appendChild(createFontFace)
        document.head.appendChild(fontface)
      }
    },
    addFonts (state, data) {
      state.font.added.unshift(data)
    },
    delFonts (state, data) {
      state.font.added = state.font.added.filter(f => f.family !== data.family)
      if (state.font.default === data.family) {
        state.font.default = 'Pretendard'
      }
      if (state.font.default2 === data.family) {
        state.font.default2 = ''
      }
      if (state.font.default3 === data.family) {
        state.font.default3 = ''
      }
    },
    updateMain (state, data) {
      state.main[data.target] = data.data
    },
    updateLogo (state, data) {
      state.site.logo = data
    },
    updateImg (state, data) {
      state.imgs[data.target] = data.value
    },
    setOrder (state, data) {
      state.order = data
    },
    setResponsive (state, data) {
      const mode = data.responsive
      const other = mode === 'tablet' ? 'mobile' : 'tablet'
      const origin = data.setting
      state.responsive[other] = _.cloneDeep(origin)
      state.site.logo = state.responsive[mode].site ? state.responsive[mode].site.logo : _.cloneDeep(origin.site.logo)
      state.colors = state.responsive[mode].colors || _.cloneDeep(origin.colors)
      state.imgs = state.responsive[mode].imgs || _.cloneDeep(origin.imgs)
      state.footer = state.responsive[mode].footer || _.cloneDeep(origin.footer)
    },
    setGuestType (state, data) {
      state.guestType = data
    }
  },
  actions: {
    initLang ({ state }) {
      state.lang.current = state.lang.default
      return true
    },
    setData ({ state, commit, dispatch, getters }, d) {
      const data = d.data
      const responsive = d.responsive || 'mobile'
      function setDefaultFont (font) {
        const defaultFont = font.default
        const defaultFont2 = font.default2
        const defaultFont3 = font.default3
        const fontList = LOCAL_FONT_LIST.concat(font.added || [])
        const hasDefaultFont = fontList.find(x => x.family === defaultFont)
        const hasDefaultFont2 = fontList.find(x => x.family === defaultFont2)
        const hasDefaultFont3 = fontList.find(x => x.family === defaultFont3)
        state.font.default = hasDefaultFont ? defaultFont : font.default
        state.font.default2 = hasDefaultFont2 ? defaultFont2 : font.default2 || ''
        state.font.default3 = hasDefaultFont3 ? defaultFont3 : font.default3 || ''
      }
      function setDefaultLangOrder (langList, defaultLangCode) {
        const usedLangs = langList.filter(x => x.u)

        // 순서정보가 없을 경우
        const defaultLang = usedLangs.find(lang => lang.c === defaultLangCode)
        const others = usedLangs.filter(lang => lang.c !== defaultLangCode)

        const translated = others.filter(lang => lang.t).sort((a, b) => a.c.localeCompare(b.c))
        const notTranslated = others.filter(lang => !lang.t).sort((a, b) => a.c.localeCompare(b.c))

        const result = defaultLang
          ? [defaultLang, ...translated, ...notTranslated]
          : [...translated, ...notTranslated]
        return result.map(x => x.c)
      }
      state.site.title = Object.assign(state.site.title, data.title)
      state.site.logo = data.logo
      state.colors = Object.assign(state.colors, data.colors)
      state.pointcolors = Object.assign(state.pointcolors, data.pointcolors)
      state.lang.default = data.lang.default
      state.lang.current = data.lang.default
      state.lang.usable = data.lang.usable
      state.lang.info.forEach(function (x, i) {
        state.lang.info[i].u = data.lang.usable.includes(x.c)
      })
      state.lang.priorityAgent = data.lang.priorityAgent
      state.lang.hiddenLangFlag = data.lang.hiddenLangFlag
      state.lang.langOrder = data.lang.langOrder && data.lang.langOrder.length > 0 ? data.lang.langOrder : setDefaultLangOrder(state.lang.info, state.lang.default)
      store.commit('preview/setLang', data.lang.default)
      state.currency.default = data.currency
      state.currency.disabledCurrencySymbol = data.disabledCurrencySymbol
      state.currency.displayCurrencyType = data.displayCurrencyType || 'symbol'
      state.currency.displayCurrencyUnit = data.displayCurrencyUnit || LANG.valueObj(`${getters.getCurrency}{price}`)
      state.date.default = data.dateformatDefault
      state.main = data.main
      state.font.added = data.addedFont
      if (data.addedFont.length > 0) {
        data.addedFont.forEach(function (font) {
          commit('setFontFace', font)
        })
      }
      if (typeof (data.lang.manual) !== 'undefined' && data.lang.manual.length > 0) {
        state.lang.manual = data.lang.manual
        state.lang.info.forEach(function (x, i) {
          state.lang.info[i].t = data.lang.manual.includes(x.c)
        })
      }
      if (data.imgs) {
        state.imgs = Object.assign(state.imgs, data.imgs)
      }
      if (data.responsive) {
        state.responsive = _.merge(state.responsive, data.responsive)
        state.site.logo = data.responsive[responsive].site.logo
        state.colors = Object.assign(state.responsive[responsive].colors, data.responsive[responsive].colors)
        state.imgs = data.responsive[responsive].imgs
      }
      state.skin = Object.assign(state.skin, data.skin)
      state.footer = Object.assign(state.footer, data.footer)
      state.order = Object.assign(state.order, data.order)
      state.mypage = Object.assign(state.mypage, data.mypage)
      state.inroom = Object.assign(state.inroom, data.inroom)
      dispatch('getGuestTypes').then((res) => {
        state.guestType = res ? res.map(x => {
          const type = data.guestType && data.guestType.find(g => g.id === x)
          const name = `${x} discount`
          return {
            id: x,
            name: type ? type.name : LANG.valueObj(name),
            active: type ? type.active || false : false,
            hide: type ? type.hide || false : false,
            discount: type ? type.discount || '' : '',
            percent: {
              active: type && type.percent ? type.percent.active : false,
              incDec: type && type.percent ? type.percent.incDec : 'dec',
              value: type && type.percent ? type.percent.value : 0
            },
            price: {
              active: type && type.price ? type.price.active : false,
              incDec: type && type.price ? type.price.incDec : 'dec',
              value: type && type.price ? type.price.value : 0
            }
          }
        }) : []
      })
      setDefaultFont(data.font)
      return true
    },
    async getCurrency ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-currency`).then((result) => {
          const currency = result.data.message.map(x => {
            return {
              n: x.currency,
              c: x.code.toLowerCase(),
              e: x.symbol
            }
          })
          state.currency.info = [
            ...new Map(
              [...state.currency.info, ...currency]
                .map(item => [item.c, item])
            ).values()
          ]
          return result
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return false
      }
    },
    async getGuestTypes ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-manage',
          func: 'get-guest-types',
          id: store.state.authentication.requestId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getCheckinInfo ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-center',
          func: 'get-checkin-info',
          id: store.state.authentication.requestId
        })
        state.checkinInfo = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getSetting ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'setting/setting.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setSetting ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'setting/setting.json',
          data: JSON.stringify(data)
        })
        return res
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setSettingData ({ state, dispatch, commit }) {
      dispatch('getCurrency')
      dispatch('getCheckinInfo')
      return dispatch('getSetting').then(res => {
        if (res) {
          res.colors = {
            ...res.colors,
            activeMenuBg: res.responsive.tablet.colors.activeMenuBg || res.responsive.tablet.colors.menuText || res.colors.menuText || 'rgba(255, 255, 255, 1)',
            activeMenuText: res.responsive.tablet.colors.activeMenuText || res.responsive.tablet.colors.menuBg || res.colors.menuBg || 'rgba(19,19,19,1)'
          }
          res.responsive = {
            mobile: {
              ...res.responsive.mobile,
              colors: {
                ...res.responsive.mobile.colors,
                activeMenuBg: res.responsive.tablet.colors.activeMenuBg || res.responsive.tablet.colors.menuText || res.colors.menuText || 'rgba(255, 255, 255, 1)',
                activeMenuText: res.responsive.tablet.colors.activeMenuText || res.responsive.tablet.colors.menuBg || res.colors.menuBg || 'rgba(19,19,19,1)',
              }
            },
            tablet: {
              ...res.responsive.tablet,
              colors: {
                ...res.responsive.tablet.colors,
                activeMenuBg: res.responsive.tablet.colors.activeMenuBg || res.responsive.tablet.colors.menuText || res.colors.menuText || 'rgba(255, 255, 255, 1)',
                activeMenuText: res.responsive.tablet.colors.activeMenuText || res.responsive.tablet.colors.menuBg || res.colors.menuBg || 'rgba(19,19,19,1)',
              }
            }
          }
          dispatch('setData', { data: res, responsive: 'mobile' })
        } else {
          commit('init')
          const initData = {
            latest: new Date().toISOString(),
            title: state.site.title,
            logo: state.site.logo,
            colors: state.colors,
            pointcolors: state.pointcolors,
            lang: {
              default: state.lang.default,
              usable: state.lang.usable,
              usableList: state.lang.info.filter(x => x.u),
              manual: state.lang.manual,
              priorityAgent: state.lang.priorityAgent,
              hiddenLangFlag: state.lang.hiddenLangFlag,
              langOrder: state.lang.langOrder
            },
            currency: state.currency.info.find(x => x.c === state.currency.default).c,
            currencyEntity: state.currency.info.find(x => x.c === state.currency.default).e,
            disabledCurrencySymbol: state.currency.disabledCurrencySymbol,
            displayCurrencyType: state.currency.displayCurrencyType,
            displayCurrencyUnit: state.currency.displayCurrencyUnit,
            dateFormat: state.date.dateFormat,
            dateformatDefault: state.date.default,
            font: {
              added: state.font.added,
              default: state.font.default,
              default2: state.font.default2,
              default3: state.font.default3
            },
            addedFont: state.font.added,
            main: state.main,
            skin: state.skin,
            responsive: state.responsive,
            footer: state.footer,
            order: state.order,
            guestType: state.guestType,
            checkinInfo: state.checkinInfo,
            mypage: state.mypage,
            inroom: state.inroom
          }
          // dispatch('setSetting', initData)
          return initData
        }
        return res
      }).catch((ex) => {
        // console.error('error:', ex)
        return false
      })
    }
  },
  getters: {
    getData: state => {
      return state
    },
    getCurrency: state => {
      return state.currency.info.find(x => x.c === state.currency.default).e
    },
    getCurrencyCode: state => {
      return state.currency.info.find(x => x.c === state.currency.default).c
    },
    getMain: state => {
      return state.main
    },
    getDateFormat (state) {
      return state.date.dateFormat[state.date.default]
    },
    getManualTranslate: state => state.lang.manual,
    getFonts: state => {
      return LOCAL_FONT_LIST.concat(state.font.added).map(x => x.family)
    },
    getLangValues: (state, getters) => val => {
      const usable = getters?.getData?.lang?.usable || []
      const result = {}
      usable.forEach(k => {
        result[k] = val || ''
      })
      return result
    }
  }
}
